import { useState } from "react";
import { collectionRef } from "@/api/firebase/collectionOperations";
import { useCurrentUserProfile } from "@/store/auth/userProfile.store";
import { timestamp } from "@/api/firebase/firebase.config";

export const useApplyForJob = () => {
  const user = useCurrentUserProfile((s) => s.user);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const handleApply = async (job_id: string, uid: string) => {
    if (!user) {
      setError(new Error("User not authenticated"));
      return;
    }

    setLoading(true);
    try {
      await collectionRef.ProfileJobJunction.doc(`${uid}_${job_id}`).set({
        job_id: job_id,
        uid: uid,
        status: "applied",
        created_at: timestamp.now(),
        updated_at: timestamp.now(),
      });
      setLoading(false);
    } catch (error) {
      setError(error as Error);
      setLoading(false);
    }
  };

  return { handleApply, loading, error };
};
